import React from 'react';
import { Button, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import Ws from '../../providers/Ws';
import FromServer from './FromServer';
import Utils from '../../providers/Utils';


export default class AI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listPrediction: null,
            nrEtape:null,
            nrTaskuri:null
        }
    }

    componentDidMount() {
    }

    getRecomandari = async () => {

        // console.log('enter function :');

        let ws = new Ws();

        let fS = new FromServer();

        let u = new Utils();

        let getInfoProiect = await fS.getInfoProiect(this.props.idproiect);

        // console.log('getInfoProiect :', getInfoProiect);



        let cloneProiect = getInfoProiect[0]

        cloneProiect.perioada_dela = u.ParseDataFromSql(cloneProiect.perioada_dela)

        cloneProiect.perioada_panala = u.ParseDataFromSql(cloneProiect.perioada_panala)


        let getData = await new Ws().getData('Predictor/ComputeProjectMatchOnNameDescription/', {
            title: getInfoProiect[0].titlu,
            description: getInfoProiect[0].descriere || 'x'
        })


        if (getData.Succes) {
            this.setState({ listPrediction: [getData.Content] }, () => {
                // console.log('getData :', getData);
                // console.log('this.state.listPrediction :', this.state.listPrediction);
            })
        }
        // console.log('getData :', getData);
    }


    getEtapeOrTasks = async(scop) =>{
        let ws = new Ws();
        let fS = new FromServer();

        let u = new Utils();

        let getInfoProiect = await fS.getInfoProiect(this.props.idproiect);

        // console.log('getInfoProiect :', getInfoProiect);

        let getData = await ws.getData('Predictor/AIComputeTasks',
    {idProject:getInfoProiect[0].id,
    scop:scop})

    // console.log('getData :', getData);
    if (getData.Succes) {
        // console.log('getData :', getData);

        if(scop === 'taskuri'){
            this.setState({nrTaskuri:Number(getData.Content).toFixed(0)})
        }else{
            this.setState({nrEtape:Number(getData.Content).toFixed()})
        }
        // this.setState({ listPrediction: [getData.Content] }, () => {
        //     console.log('getData :', getData);
        //     console.log('this.state.listPrediction :', this.state.listPrediction);
        // })
    }
    // console.log('getData :', getData);
    }

    
    render() {
        return (
            <div>

                <div className='container'>


                    <Button
                        onClick={this.getRecomandari}
                        style={{

                            marginBottom: 20,
                            backgroundColor: '#22c2ff',
                            color: 'white'

                        }}
                        variant="contained" >
                        Recomandari rapide
                          </Button> <br />

                    <span className='pm-title'>Algoritm de inteligenta artificiala care propune nr de etape si sau taskuri in functie de proiectele similare
                                                bazat pe descrierea proiectului</span>
                    {
                        this.state.listPrediction &&
                        <div className='container' style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Durata Zile
                                        </TableCell>
                                        <TableCell>
                                            Numar Etape
                                        </TableCell>
                                        <TableCell>
                                            Numar Taskuri
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.listPrediction.map((p, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {p.durata_zile}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {p.nr_etape}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {p.nr_taskuri}
                                                </TableCell>



                                            </TableRow>
                                        )
                                    })}


                                </TableBody>
                            </Table>
                        </div>

                    }

                </div>

                <div className='container'>


                    <Button
                        onClick={()=>{this.getEtapeOrTasks('taskuri')}}
                        style={{

                            marginBottom: 20,
                            backgroundColor: 'rgb(49, 218, 163)',
                            color: 'white'

                        }}
                        variant="contained" >
                       Propunere numar taskuri
           </Button> <br />

                    <span className='pm-title'>Algoritm de inteligenta artificiala care propune nr de taskuri in functie de proiectele similare bazat pe statisticile colectate din istoricul proiectelor</span>
                    {
                        this.state.nrTaskuri &&
                        <div className='container' style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                       
                                        <TableCell>
                                            Numar Taskuri
                         </TableCell>
                         <TableCell>
                                           {this.state.nrTaskuri}
                         </TableCell>

                                    </TableRow>
                                </TableHead>
                                
                            </Table>
                        </div>

                    }

                </div>

                <div className='container'>


                    <Button
                       onClick={()=>{this.getEtapeOrTasks('etape')}}
                        style={{

                            marginBottom: 20,
                            backgroundColor: 'rgb(228, 131, 47)',
                            color: 'white'

                        }}
                        variant="contained" >
                       Propunere numar etape
           </Button> <br />

                    <span className='pm-title'>Algoritm de inteligenta artificiala care propune nr de etape in functie de proiectele similare bazat pe statisticile colectate din istoricul proiectelor</span>
                    {
                        this.state.nrEtape &&
                        <div className='container' style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                   
                                        <TableCell>
                                            Numar Etape
                                        </TableCell>
                                        <TableCell>
                                          {this.state.nrEtape}
                                        </TableCell>
                                        

                                    </TableRow>
                                </TableHead>
                               
                            </Table>
                        </div>

                    }

                </div>
            </div>
        );
    }
}